import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { AiFillDelete} from "react-icons/ai";
import { Link, useNavigate } from 'react-router-dom'


function UserPost() {

  const [data, setData] = useState([])
  const [useId, setUserId] = useState('')
  const [token, setToken] = useState('')
  const[spin,SetSpin]=useState([1])


  useEffect(() => {
    setUserId(localStorage.getItem('useuserId'))
    setToken(localStorage.getItem('token'))

  }, [])





  setTimeout(async () => {



  }, 1000)







  const navigate = useNavigate()

  const DeletePost = async (a) => {

    // e.preventDefault()

    await axios.delete('https://rahulbloging.onrender.com/deletPost', {
      headers: {
        'UserId': a,
        'token': token
      }
    })

      .then((result) => {
        console.log(result.data.data)
        alert('Post Delete SuccesFully')
        navigate('/')

      })
      .catch((err) => {
        console.log(err)

        alert(err.response.data.msg)
      })


  }





  const handlePost = async () => {
    SetSpin([])
    await axios.get('https://rahulbloging.onrender.com/getpost', {
      headers: {
        'PostId': useId,
      }
    })

      .then((result) => {
        console.log(result.data.data)
        setData(result.data.data)
        SetSpin([1])
      })
      .catch((err) => {
        console.log(err)

        alert(err.response.data.msg)
      })

  }




  return (
    <div id='up'>
      <div id='but'>
        <button id='butt' onClick={handlePost} className=''>Get Blog</button>
      </div>


      <div className="container d-flex flex-wrap">



        {
          spin.length == 0 ? 
                    <div className="round">
                         <div class="loader"></div>
                         
                    </div> 
                    :

          data.map((a) => {

            return (

              <div id='uc' class="card m-1 bg-warning" style={{ width: "420px",height:"430px" }}>
                <img id='x' src={a.imageUrl} class="card-img-top " style={{ height:"310px",objectFit:"fill"  }} alt="..." />
                <div class="card-img-overlay ">
                  <h onClick={() => DeletePost(a._id)} id='delete' to="#"><AiFillDelete/></h>
                </div>
                <div class="card-body">
                  <h3 style={{textAlign:"center"}}>{a.title}</h3>
                  <p style={{color:'white'}}> {a.description}</p>
                </div>
              </div>

            )

          })
        }





      </div>
    </div>
  )
}

export default UserPost
